export default "__VITE_ASSET__BBlUTRWO__";